module.exports = __webpack_public_path__ + "img/Spotify_logo_full_white.31bad8d4.png";